import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '../lib/cn.js';

const alertVariants = cva(
  'relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground',
  {
    variants: {
      variant: {
        default: 'bg-background text-foreground',
        destructive:
          'border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive',
        /*
         * Bandeau pleine largeur de la coque (adresse non vérifiée, essai, impayé…) : compact, sur
         * la surface des cartes, pour informer sans concurrencer la page. Un mot insécable — une
         * adresse e-mail — passe à la ligne au lieu de glisser sous les boutons. `data-tone`
         * « urgent » le teinte d'avertissement.
         */
        banner:
          'rounded-none border-x-0 border-t-0 bg-card px-4 py-2.5 text-foreground md:px-6 [&>svg]:left-4 [&>svg]:top-[1.125rem] [&>svg]:text-muted-foreground md:[&>svg]:left-6 max-sm:[&>svg]:top-3 [&>svg+div]:translate-y-0 [&_span]:[overflow-wrap:anywhere] max-sm:[&>div>span:first-child]:basis-full data-[tone=urgent]:bg-warning/10 data-[tone=urgent]:[&>svg]:text-warning',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

export function AlertTitle({ className, ...props }: React.ComponentProps<'h5'>) {
  return (
    <h5 className={cn('mb-1 font-medium leading-none tracking-tight', className)} {...props} />
  );
}

export function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('text-sm [&_p]:leading-relaxed', className)} {...props} />;
}

export { alertVariants };
